import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type {
  StoreSettlementDetail,
  StoreSettlementParams,
} from '~/features/dashboard/types/settlement.type';

/**
 * 매장별 정산 상세 조회
 * @endpoint GET /admin/dashboard/settlement/overview/stores/:storeId
 */
export function getSettlementStoreDetailApi(params: StoreSettlementParams) {
  return axiosInstance.get<ApiResponse<StoreSettlementDetail | null>>(
    `/admin/dashboard/settlement/overview/stores/${params.storeId}`,
    {
      params: {
        startDate: params.startsAt,
        endDate: params.endsAt,
      },
    },
  );
}
